import { MojoNgxAngularQueryBuilderModule  } from './../query-builder/query-builder.module';
import { ValidationMessagesComponent } from './dynamic-form/components/validation-messages/validation-messages.component';
import { DynamicFormComponent } from './dynamic-form/containers/dynamic-form/dynamic-form.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { MultiSelectModule } from 'primeng/multiselect';
import { ButtonModule } from 'primeng/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QuillModule } from 'ngx-quill';
import { AdditionalInformationAdminModule } from '../additional-information/additional-information-admin.module';
import { DebtorAccountHistoryWidgetSelectionComponentModule } from '../debtor-account-history-widget/debtor-account-history-widget-selection-component.module';

@NgModule({
  declarations: [
    DynamicFormComponent,
    ValidationMessagesComponent
  ],
  exports: [
    DynamicFormComponent,
    ValidationMessagesComponent,
  ],
  imports: [
    CommonModule,
    MojoNgxAngularQueryBuilderModule ,
    FormsModule, ReactiveFormsModule,
    QuillModule.forRoot({
      modules: {
        // ensure sanitize is on for all quill stuff globally
        sanitize: true,
      }
    }),
    DropdownModule,
    TableModule,
    MultiSelectModule,
    ButtonModule,
    AdditionalInformationAdminModule,
    DebtorAccountHistoryWidgetSelectionComponentModule
  ],
})
export class DynamicFormsModule { }
